(() => {
  const carouselSelector = '.main-product__trust-carousel, [data-yx-review-carousel]';

  const buildPager = (carousel) => {
    const track = carousel.querySelector('.main-product__trust-track, [data-yx-review-carousel-track]');
    const dotsWrap = carousel.querySelector('.main-product__trust-dots, [data-yx-review-carousel-dots]');
    const cards = track ? Array.from(track.children) : [];
    if (!track || !dotsWrap || cards.length < 2 || track.clientWidth === 0) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const cardStep = cards[1].offsetLeft - cards[0].offsetLeft;
    if (cardStep <= 0) return;

    const stops = [0];
    for (let position = cardStep; position < maxScroll - 0.5; position += cardStep) stops.push(position);
    if (maxScroll > 0 && Math.abs(stops[stops.length - 1] - maxScroll) > 0.5) stops.push(maxScroll);

    dotsWrap.replaceChildren();
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'group');
    const isCustomerReviews = carousel.matches('[data-yx-review-carousel]');
    const isSpanish = (document.documentElement.lang || '').toLowerCase().startsWith('es');
    const pagesLabel = isCustomerReviews
      ? (isSpanish ? 'Páginas de reseñas de clientes' : 'Customer review pages')
      : (isSpanish ? 'Páginas de reseñas de Trustpilot' : 'Trustpilot review pages');
    dotsWrap.setAttribute('aria-label', pagesLabel);
    const dots = stops.map((position, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', isCustomerReviews
        ? (isSpanish
            ? `Mostrar la página ${index + 1} de ${stops.length} de reseñas`
            : `Show customer review page ${index + 1} of ${stops.length}`)
        : (isSpanish
            ? `Mostrar la página ${index + 1} de ${stops.length} de reseñas de Trustpilot`
            : `Show Trustpilot review page ${index + 1} of ${stops.length}`));
      const goToPosition = () => track.scrollTo({ left: position, behavior: 'smooth' });
      dot.addEventListener('click', goToPosition);
      dotsWrap.append(dot);
      return dot;
    });

    const sync = () => {
      const active = stops.reduce((closestIndex, position, index) => (
        Math.abs(position - track.scrollLeft) < Math.abs(stops[closestIndex] - track.scrollLeft)
          ? index
          : closestIndex
      ), 0);
      dots.forEach((dot, index) => {
        const isActive = index === active;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    if (carousel._yxTrustPagerSync) track.removeEventListener('scroll', carousel._yxTrustPagerSync);
    carousel._yxTrustPagerSync = sync;
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  };

  const setupCarousel = (carousel) => {
    let queued = false;
    const rebuild = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        buildPager(carousel);
      });
    };
    const track = carousel.querySelector('.main-product__trust-track, [data-yx-review-carousel-track]');
    if (!track) return;
    let dragging = false;
    let dragMoved = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    track.addEventListener('pointerdown', (event) => {
      dragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      if (Math.abs(event.clientX - dragStartX) > 6) {
        dragMoved = true;
        if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
      }
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });
    ['pointerup', 'pointercancel'].forEach((type) => track.addEventListener(type, () => {
      dragging = false;
      track.classList.remove('is-dragging');
      if (dragMoved) {
        carousel.dataset.yxSuppressClick = 'true';
        window.setTimeout(() => { delete carousel.dataset.yxSuppressClick; }, 0);
      }
    }));
    new ResizeObserver(rebuild).observe(track);
    window.addEventListener('resize', rebuild, { passive: true });
    rebuild();
  };

  const init = () => document.querySelectorAll(carouselSelector).forEach((carousel) => {
    if (carousel.dataset.yxReviewCarouselReady === 'true') return;
    carousel.dataset.yxReviewCarouselReady = 'true';
    setupCarousel(carousel);
  });
  document.addEventListener('yx:customer-reviews-ready', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
